import { useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { useEffect } from "react";
export function useEffectAssignWhen(setting, assignWhen) {
    var assign = useAssignSetting(setting);
    useEffect(function() {
        if (assignWhen) {
            assign();
        }
    }, [
        assignWhen,
        assign
    ]);
}
